import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MainComponent } from './components/main/main.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { LoadingComponent } from './components/loading/loading.component';
import { SafeHtmlPipe } from './pipes/safe.pipe';

@NgModule({
    imports: [CommonModule, RouterModule, ReactiveFormsModule],
    providers: [LoadingComponent],
    declarations: [MainComponent, PaginationComponent, LoadingComponent, SafeHtmlPipe],
    exports: [MainComponent, PaginationComponent, LoadingComponent, SafeHtmlPipe]
})
export class SharedModule {}
